<template>
    <div class="footer-logo"
         @mouseover="hoverOn = true"
         @mouseleave="hoverOn = false">
        <router-link :to="{ path: '/' }"
                     class="logo-link-wrapper">
            <footer-logo-svg :hover-on="hoverOn" />
        </router-link>
    </div>
</template>

<script>
    import FooterLogoSvg from '../svgs/FooterLogoSvg'

    export default {
        name: "FooterLogo",
        components: { FooterLogoSvg },
        data() {
            return {
                hoverOn: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .footer-logo {
        width: min-content;
    }
</style>